import React from 'react';
import PropTypes from 'prop-types';

/**
 * Renders the title section element with dynamic visibility classes.
 *
 * @param {object} props - Component props.
 * @param {string} props.title - The title text (e.g., 'IN' or 'OUT').
 * @param {string} [props.cssClass] - CSS modifier for title styling.
 * @param {string} props.visibilityClass - Responsive visibility utility class.
 * @returns {React.JSX.Element} The title section component.
 */
export const InsOutsTitleSection = ({ title, cssClass, visibilityClass }) => {
    const modifierClass = cssClass
        ? ` team-lineups-ins-and-outs__title--${cssClass}`
        : '';

    return (
        <div className={`team-lineups__title-section ${visibilityClass}`}>
            <div className="team-lineups-ins-and-outs__title-wrapper">
                <p
                    className={`team-lineups-ins-and-outs__title${modifierClass}`}
                >
                    {title}
                </p>
            </div>
        </div>
    );
};

InsOutsTitleSection.propTypes = {
    title: PropTypes.string.isRequired,
    cssClass: PropTypes.string,
    visibilityClass: PropTypes.string.isRequired
};
